import { IconPresentationProps } from "@insite/mobius/Icon";
import React from "react";

const ArrowDown: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path d="M1 1L5 5L9 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default React.memo(ArrowDown);
